import {Animation} from './animation';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;

const Tween = TweenMax;
const TimeLine = TimelineMax;

const ROUND_TIME = 2.4;     // время (сек.), за которое колесо совершает полный круг
const BREAKING_TIME = 5;    // время торможения

/**
 * Class representing roulette
 * @extends PIXI.Container
 */

export default class RouletteScene extends PIXI.Container {
    
    /**
     * Creates a roulette
     * */
    constructor( parent )
    {
        super();
        
        this.space = parent.child( "roulette" );
    
        this.$animating = this.space.s( "animating", false );
        this.$start = this.space.s( "start" );
    
        
        const PATH = 'res/common/roulette';
        
        this._background = new Sprite(TextureCache[`${PATH}/background.jpg`]);
        this._background.scale.set(1366/1024, 1);
        this.addChild(this._background);
    
        this._background.interactive = true;
        this._background.buttonMode = true;
        this._background.cursor = 'inherit';
    
    
        var onClick = function () {
            this.$start.next();
        }.bind(this);
    
        // mouse-only
        this._background.on('click', onClick);
        // touch-only
        this._background.on('tap', onClick);
        
        
        this._pressStartLabel = new Sprite(TextureCache[`${PATH}/press_start.png`]);
        this._pressStartLabel.anchor.set(0.5, 0);
        this._pressStartLabel.position.set(1366/2, 690);
        this._pressStartLabel.visible = false;
        this.addChild(this._pressStartLabel);
    
        this._waitingLabel = new Sprite(TextureCache[`${PATH}/waiting.png`]);
        this._waitingLabel.anchor.set(0.5, 0);
        this._waitingLabel.position.set(1366/2, 698);
        this._waitingLabel.visible = false;
        this.addChild(this._waitingLabel);
        
        // this._jackpotRouletteLabel = new Sprite(TextureCache[`${PATH}/jackpot_roulette.png`]);
        // this._jackpotRouletteLabel.position.set(42, 0);
        // this.addChild(this._jackpotRouletteLabel);
        
        this._jackpotRouletteLabelAnimation = Animation.byFrameName('roulette_label_blink_%03d.png', 30);
        this.addChild(this._jackpotRouletteLabelAnimation);
        this._jackpotRouletteLabelAnimation.position.set(42, 0);
        this._jackpotRouletteLabelAnimation.loop = true;
        this._jackpotRouletteLabelAnimation.animationSpeed = 0.5;
        this._jackpotRouletteLabelAnimation.visible = false;

        
        // this._fork = new Sprite(TextureCache[`${PATH}/fork.png`]);
        // this._fork.position.set(620, 2); // 0
        // this.addChild(this._fork);
        //
        // this._trunk = new Sprite(TextureCache[`${PATH}/trunk.png`]);
        // this._trunk.position.set(446, 342);
        // this.addChild(this._trunk);
    
/*
        this._yellowSphere = Animation.byFrameName('yello/yellow_sphere_%03d.png', 40);
        this.addChild(this._yellowSphere);
        this._yellowSphere.loop = false;
        this._yellowSphere.position.set(632 - 19 - 1 , 60 + 55 + 1);
        this._yellowSphere.animationSpeed = 0.4;
        this._yellowSphere.visible = false;

    
        this._greenSphere = Animation.byFrameName('green/green_sphere_%03d.png', 40);
        this.addChild(this._greenSphere);
        this._greenSphere.loop = false;
        this._greenSphere.position.set(632 + 2- 19 - 1, 222+ 55 + 3 + 2);
        this._greenSphere.animationSpeed = 0.4;
        this._greenSphere.visible = false;

    
        this._blueSphere = Animation.byFrameName('blue/blue_sphere_%03d.png', 40);
        this.addChild(this._blueSphere);
        this._blueSphere.loop = false;
        this._blueSphere.position.set(631 + 3- 19 - 1, 282 + 3);
        this._blueSphere.animationSpeed = 0.4;
        this._blueSphere.visible = false;
*/
        // this._violetSphere = Animation.byFrameName('violet/violet_sphere_%03d.png', 51);
        // this.addChild(this._violetSphere);
        // this._violetSphere.loop = false;
        // this._violetSphere.position.set(631, 284);
        // this._violetSphere.animationSpeed = 0.4;
        // this._violetSphere.visible = false;
        
        
        // this._rouletteBody = new Sprite(TextureCache[`${PATH}/roulette_body.png`]);
        // this._rouletteBody.position.set(36, 81);
        // this.addChild(this._rouletteBody);
    
    
        this._disc = new Sprite(TextureCache[`${PATH}/disc/disc_default.png`]);
        this._disc.anchor.set(0.5, 0.5);
        this._disc.position.set(327, 354);
        this.addChild(this._disc);
    
    
        // this._disc.rotation = (79 + 227) * Math.PI / 180;
        
    
    
        this._discBlue = new Sprite(TextureCache[`${PATH}/disc/disc_blue.png`]);
        this._discBlue.anchor.set(0.5, 0.5);
        this._discBlue.visible = false;
        this._disc.addChild(this._discBlue);
    
        this._discGreen = new Sprite(TextureCache[`${PATH}/disc/disc_green.png`]);
        this._discGreen.anchor.set(0.5, 0.5);
        this._discGreen.visible = false;
        this._disc.addChild(this._discGreen);
    
        this._discYellow = new Sprite(TextureCache[`${PATH}/disc/disc_yellow.png`]);
        this._discYellow.anchor.set(0.5, 0.5);
        this._discYellow.visible = false;
        this._disc.addChild(this._discYellow);
    
        // this._discViolet = new Sprite(TextureCache[`${PATH}/disc/disc_purple.png`]);
        // this._discViolet.anchor.set(0.5, 0.5);
        // this._discViolet.visible = false;
        // this._disc.addChild(this._discViolet);
        
    
        this._arrow = new Sprite(TextureCache[`${PATH}/arrow.png`]);
        this._arrow.position.set(86,122);
        this.addChild(this._arrow);
    
    
    
        this._yellowSubstrate = new Sprite(TextureCache[`${PATH}/yellow_substrate.png`]);
        this._yellowSubstrate.position.set(795- 19, 27 + 57);
        this.addChild(this._yellowSubstrate);
        this._yellowSubstrate.visible = false;
    
        this._greenSubstrate = new Sprite(TextureCache[`${PATH}/green_substrate.png`]);
        this._greenSubstrate.position.set(795- 19, 193 + 83);
        this.addChild(this._greenSubstrate);
        this._greenSubstrate.visible = false;
        
        this._blueSubstrate = new Sprite(TextureCache[`${PATH}/blue_substrate.png`]);
        this._blueSubstrate.position.set(795- 19, 359 + 109);
        this.addChild(this._blueSubstrate);
        this._blueSubstrate.visible = false;

        // this._violetSubstrate = new Sprite(TextureCache[`${PATH}/violet_substrate.png`]);
        // this._violetSubstrate.position.set(795, 525);
        // this.addChild(this._violetSubstrate);
        // this._violetSubstrate.visible = false;

        
        this._megaJackpotTintColor = 0xffff00;
        this._superJackpotTintColor = 0x90ff00;
        this._jackpotTintColor = 0x00deff;
        // this._bonusTintColor = 0xff00ff;
    
        this._megaJackpotWinLabel = new PIXI.extras.BitmapText("0", {font: "roulette_digits", align: "center"});
        this.addChild(this._megaJackpotWinLabel);
        this._megaJackpotWinLabel.position.set(1060 - 19, 45 + 57);
        this._megaJackpotWinLabel.anchor.set(0.5, 0);
        this._megaJackpotWinLabel.tint = this._megaJackpotTintColor;
    
        this._superJackpotWinLabel = new PIXI.extras.BitmapText("0", {font: "roulette_digits", align: "center"});
        this.addChild(this._superJackpotWinLabel);
        this._superJackpotWinLabel.position.set(1060 - 19, 215 + 83);
        this._superJackpotWinLabel.anchor.set(0.5, 0);
        this._superJackpotWinLabel.tint = this._superJackpotTintColor;
    
        this._jackpotWinLabel = new PIXI.extras.BitmapText("0", {font: "roulette_digits", align: "center"});
        this.addChild(this._jackpotWinLabel);
        this._jackpotWinLabel.position.set(1060 - 19, 380 + 109);
        this._jackpotWinLabel.anchor.set(0.5, 0);
        this._jackpotWinLabel.tint = this._jackpotTintColor;
    
        // this._bonusLabel = new Sprite(TextureCache[`${PATH}/bonus.png`]);
        // this._bonusLabel.position.set(910, 556);
        // this.addChild(this._bonusLabel);
        // this._bonusLabel.tint = this._bonusTintColor;
    
    
        this._jackpotQuestionMark = new Sprite(TextureCache[`${PATH}/question_mark.png`]);
        this._jackpotQuestionMark.position.set(1000, 120 + 57);
        this.addChild(this._jackpotQuestionMark);
    
        this._superJackpotQuestionMark = new Sprite(TextureCache[`${PATH}/question_mark.png`]);
        this._superJackpotQuestionMark.position.set(1000, 285 + 83 + 3);
        this.addChild(this._superJackpotQuestionMark);
    
        this._megaJackpotQuestionMark = new Sprite(TextureCache[`${PATH}/question_mark.png`]);
        this._megaJackpotQuestionMark.position.set(1000, 450 + 109 + 3);
        this.addChild(this._megaJackpotQuestionMark);
    
    
        const SND_PATH = 'res/common/sounds/roulette';
        
        this._sndSuperJackpot = sounds.get(`${SND_PATH}/super_jackpot`);
        this._sndMegaJackpot = sounds.get(`${SND_PATH}/mega_jackpot`);
        this._sndJackpot = sounds.get(`${SND_PATH}/jackpot`);
        // this._sndBonus = sounds.get(`${SND_PATH}/bonus`);
    
        this._sndImpact = sounds.get(`${SND_PATH}/impact`);
        this._sndGold = sounds.get(`${SND_PATH}/gold`);
        this._sndEnd = sounds.get(`${SND_PATH}/end`);
    
        this._sndMusic = sounds.get(`${SND_PATH}/music`);
    }
    
    
    terminate () {
        console.log('ROULETTE TERMINATE!!!');
        
        this.removeChildren();
        this.destroy();
        
        this.$animating = null;
    
        this.$start = null;
    
        this._background.removeListener('click');
        this._background.removeListener('tap');
    
        this._background = null;
    
        this._pressStartLabel = null;
    
        this._waitingLabel = null;
    
        // this._jackpotRouletteLabel = null;
    
        this._jackpotRouletteLabelAnimation.destroy();
        this._jackpotRouletteLabelAnimation = null;
    
        // this._fork = null;
        //
        // this._trunk = null;
        //
        // this._yellowSphere.destroy();
        // this._yellowSphere = null;
        //
        // this._greenSphere.destroy();
        // this._greenSphere = null;
        //
        // this._blueSphere.destroy();
        // this._blueSphere = null;
    
        // this._violetSphere = null;
    
        // this._rouletteBody = null;
    
        this._disc = null;
    
        this._discBlue = null;
    
        this._discGreen = null;
    
        this._discYellow = null;
    
        // this._discViolet = null;
    
        this._arrow = null;
    
        this._yellowSubstrate = null;
    
        this._greenSubstrate = null;
    
        this._blueSubstrate = null;
    
        // this._violetSubstrate = null;
    
        this._megaJackpotWinLabel = null;
    
        this._superJackpotWinLabel = null;
    
        this._jackpotWinLabel = null;
    
        // this._bonusLabel = null;
    
        this._jackpotQuestionMark = null;
    
        this._superJackpotQuestionMark = null;
    
        this._megaJackpotQuestionMark = null;
    
        this._sndSuperJackpot.stop();
        delete this._sndSuperJackpot;
        this._sndMegaJackpot.stop();
        delete this._sndMegaJackpot;
        this._sndJackpot.stop();
        delete this._sndJackpot;
        // this._sndBonus.stop();
        // delete this._sndBonus;
    
        this._sndImpact.stop();
        delete this._sndImpact;
        this._sndGold.stop();
        delete this._sndGold;
        this._sndEnd.stop();
        delete this._sndEnd;
    
        this._sndMusic.stop();
        delete this._sndMusic;
        
        if ( this._blinkTween )
        {
            this._blinkTween.kill();
            delete this._blinkTween;
        }
        if ( this._rotationTween )
        {
            this._rotationTween.kill();
            delete this._rotationTween;
        }
    
        if (this.drivingTween) {
            this.drivingTween.kill();
            delete this.drivingTween;
        }
    
        if (this.breakingTween) {
            this.breakingTween.kill();
            delete this.breakingTween;
        }
    }
    
    /**
     * Shows scene falling down transition
     *
     * @param {Object} args - parameters
     * @param {Number} args.megaJackpotWin - megajackpot win
     * @param {Number} args.superJackpotWin - superjackpot win
     * @param {Number} args.jackpotWin - jackpot win
     * @returns {Promise} - promise to be resolved on scene transition finished
     * */
    fallDown ({megaJackpotWin, superJackpotWin, jackpotWin}) {
        
        console.log('*** ROULETTE:fallDown');
    
        this.$animating.next(true);
        
        this._megaJackpotWinLabel.text = megaJackpotWin;
        this._superJackpotWinLabel.text = superJackpotWin;
        this._jackpotWinLabel.text = jackpotWin;
    
        this._megaJackpotWinLabel.tint = this._megaJackpotTintColor;
        this._superJackpotWinLabel.tint = this._superJackpotTintColor;
        this._jackpotWinLabel.tint = this._jackpotTintColor;
        // this._bonusLabel.tint = this._bonusTintColor;
    
        this._yellowSubstrate.alpha = 1;
        this._greenSubstrate.alpha = 1;
        this._blueSubstrate.alpha = 1;
        // this._violetSubstrate.alpha = 1;
    
        this._yellowSubstrate.visible = false;
        this._greenSubstrate.visible = false;
        this._blueSubstrate.visible = false;
        // this._violetSubstrate.visible = false;
        
        
        this._discBlue.visible = false;
        this._discGreen.visible = false;
        this._discYellow.visible = false;
        // this._discViolet.visible = false;
    
        this._pressStartLabel.alpha = 1;
        this._pressStartLabel.visible = true;
        
        this._sndImpact.play();
        this.position.set(0, -768);
        this.visible = true;
    
        const blink = () => {
            this._blinkTween = new TimeLine()
                .to(this._pressStartLabel, 1, {alpha:0, ease:Sine.easeInOut})
                .yoyo(true)
                .repeat(-1)
                .play();
        };
    
        // return new Promise(resolve => {
        //     const onComplete = () => {
        //         blink();
        //         console.log('*** ROULETTE:fallDown COMPLETE');
        //         resolve();
        //     };
        //
        //     Tween.to(this.position, 0.5, {y:0, onComplete:onComplete});
        // });
    

        Tween.to(this.position, 0.5, {y:0, onComplete:() => {
            blink();
            console.log('*** ROULETTE:fallDown COMPLETE');
            this.$animating.next(false);
        }});
    }
    
    /**
     * Just makes scene invisible
     * */
    hide () {
    
        console.log('*** ROULETTE:hide');
        
        this.visible = false;
    }
   
    

    
    /**
     * Shows scene on finish state (jackpot or bonus has been won)
     * */
    onFinishState ({megaJackpotWin = 0, superJackpotWin = 0, jackpotWin = 0, result}) {
        console.log('*** ROULETTE:onFinishState');
        this._megaJackpotWinLabel.text = megaJackpotWin;
        this._superJackpotWinLabel.text = superJackpotWin;
        this._jackpotWinLabel.text = jackpotWin;
    
        this._megaJackpotWinLabel.tint = (result === 0) ? 0xffffff : this._megaJackpotTintColor;
        this._superJackpotWinLabel.tint = (result === 1) ? 0xffffff :this._superJackpotTintColor;
        this._jackpotWinLabel.tint = (result === 2) ? 0xffffff :this._jackpotTintColor;
        // this._bonusLabel.tint = (result === 3) ? 0xffffff :this._bonusTintColor;
    
    
        this._yellowSubstrate.alpha = 1;
        this._greenSubstrate.alpha = 1;
        this._blueSubstrate.alpha = 1;
        // this._violetSubstrate.alpha = 1;
        
        this._yellowSubstrate.visible = (result === 4);
        this._greenSubstrate.visible = (result === 3);
        this._blueSubstrate.visible = (result === 2);
        // this._violetSubstrate.visible = (result === 1);
        
        this.position.set(0, 0);
        
        this.visible = true;
    
        if (this._blinkTween) {
            this._blinkTween.kill();
        }
    
        this._rotationTween = null;
    }
    
    /**
     * Launch roulette infinite rotation (usually initiated by user keypress)
     * */
    startRotate () {
    
        console.log('*** ROULETTE:startRotate');
        
        this.$animating.next(true);
    
        if (this._blinkTween) {
            this._blinkTween.kill();
        }
        this._pressStartLabel.alpha = 1;
        this._pressStartLabel.visible = false;
    
        
        this._waitingLabel.visible = true;
        
        if (!this._rotationTween) {
            this._jackpotRouletteLabelAnimation.visible = true;
            this._jackpotRouletteLabelAnimation.gotoAndPlay(0);
    
            this._sndMusic.stop();
            this._sndMusic.play();
    
            this._disc.rotation = 0;
            
            this._rotationTween = Tween.to(this._disc, ROUND_TIME, {rotation:2 * Math.PI, ease:Linear.easeNone}).repeat(-1);
        }
        else {
            console.log('******** ALREADY ROTATING (assume music is playing!!!!!!)')
            
        }
    }
    
    /**
     * Convenient method for state restoration
     *
     * @param {Object} args - parameters
     * @param {Number} args.megaJackpotWin - megajackpot win
     * @param {Number} args.superJackpotWin - superjackpot win
     * @param {Number} args.jackpotWin - jackpot win
     * @param {Number} args.result - result to show
     * @param {Number} args.lifeTime - time to wait till roulette begins stop
     * */
    play ({megaJackpotWin = 0, superJackpotWin = 0, jackpotWin = 0, result, lifeTime}) {
        console.log('*** ROULETTE:play');

        this.$animating.next(true);

        //
        // return new Promise(resolve => {
        //     this.breakRotate(variant, seed).then(() => {
        //         return this.showSphereFill(variant);
        //     }).then(() => {
        //         return this.showBlinkingSubstrate(variant);
        //     }).then(() => {
        //         resolve();
        //     });
        // });
    
        // for state restoration
        this.onRotateState({megaJackpotWin, superJackpotWin, jackpotWin});
    
        
        let rotationTime = lifeTime - BREAKING_TIME;
        if (rotationTime < 0) {
            rotationTime = 0;
        }

        setTimeout(() => {
            this.breakRotate(result).then(() => {
                return this.showSphereFill(result);
            }).then(() => {
                return this.showBlinkingSubstrate(result);
            }).then(() => {
                this.$animating.next(false);
            });
        }, rotationTime * 1000);
    }
    
    /***************************************** !!! private section !!!  ***********************************************/
    
    /**
     * Shows scene on rotating state
     *
     * @param {Object} args - parameters
     * @param {Number} args.megaJackpotWin - megajackpot win
     * @param {Number} args.superJackpotWin - superjackpot win
     * @param {Number} args.jackpotWin - jackpot win
     * */
    onRotateState ({megaJackpotWin = 0, superJackpotWin = 0, jackpotWin = 0}) {
        
        console.log('*** ROULETTE:onRotateState');
        
        this._megaJackpotWinLabel.text = megaJackpotWin;
        this._superJackpotWinLabel.text = superJackpotWin;
        this._jackpotWinLabel.text = jackpotWin;
        
        this._megaJackpotWinLabel.tint = this._megaJackpotTintColor;
        this._superJackpotWinLabel.tint = this._superJackpotTintColor;
        this._jackpotWinLabel.tint = this._jackpotTintColor;
        // this._bonusLabel.tint = this._bonusTintColor;
        
        this._yellowSubstrate.alpha = 1;
        this._greenSubstrate.alpha = 1;
        this._blueSubstrate.alpha = 1;
        // this._violetSubstrate.alpha = 1;
        
        this._yellowSubstrate.visible = false;
        this._greenSubstrate.visible = false;
        this._blueSubstrate.visible = false;
        // this._violetSubstrate.visible = false;
        
        
        if (this._blinkTween) {
            this._blinkTween.kill();
            this._blinkTween = null;
        }
        
        this._pressStartLabel.alpha = 1;
        this._pressStartLabel.visible = false;
        
        this._waitingLabel.visible = true;
        this._discBlue.visible = false;
        this._discGreen.visible = false;
        this._discYellow.visible = false;
        // this._discViolet.visible = false;
        
        this.position.set(0, 0);
        this.visible = true;
        
        this.startRotate();
    }
    
    /**
     * @private
     * @description Breaks roulette rotation
     * @param {Number} variant - variant to show (need for angle calculation)
     * @returns {Promise} - promise to be resolved on roulette stop
     * */
    breakRotate (variant) {
        console.log('*** ROULETTE:breakRotate');
        
        if (this._rotationTween) {
            this._rotationTween.kill();
            this._rotationTween = null;
        }
        
        let min, max, disk;
        
        switch (variant) {
            
        case 4:// yellow
            // min = 0.5;
            // max = 23.77;
            min = 310;
            max = 357;

            disk = this._discYellow;
            break;
        
        case 3:// green
            // min = 24.77;
            // max = 65.94;
            min = 2;
            max = 75;

            disk = this._discGreen;
            break;
        
        case 2:// blue
            // min = 66.94;
            // max = 234.69;
            min = 79;
            max = 306;

            disk = this._discBlue;
            break;
        
        // case 1:// violet
        //     min = 235.69;
        //     max = 359.5;
        //     disk = this._discViolet;
        //     break;
        }
        
        let targetAngle = Math.random() * (max - min) + min;
        
        // console.log(`target angle ${targetAngle}`);
        //
        // let decelerationAngle = targetAngle - 270; // тормозим за 3/4 круга
        // if (decelerationAngle < 0) {
        //     decelerationAngle += 360;
        // }
        //
        // console.log(`deceleration angle ${decelerationAngle}`);
        //
        // if (decelerationAngle > targetAngle) {
        //     targetAngle += 360;
        //
        //     console.log(`corrected target angle ${targetAngle}`);
        // }
        
        const currentAngle = this._disc.rotation * 180 / Math.PI;
        
        // console.log(`current angle ${currentAngle}`);
        
        let delta; // сколько нужно дотвинить до начала торможения
        if (currentAngle >= targetAngle) {
            delta = 360 - currentAngle + targetAngle
        }
        else {
            delta = targetAngle - currentAngle;
        }
        
        // console.log(`delta angle ${delta}`);
    
        return new Promise(resolve => {
    
            const driveTime = ROUND_TIME * delta / 360;
   
            this.drivingTween = new Tween(this._disc, driveTime, {
                rotation:(currentAngle + delta) * Math.PI / 180,
                ease:Linear.easeNone,
                onComplete:() => {
                    this._disc.rotation = targetAngle / 180 * Math.PI;
                }
            });
    
            
            this.breakingTween = new Tween(this._disc, BREAKING_TIME, {
                rotation:(targetAngle + 360) * Math.PI / 180, ease: Sine.easeOut, //https://greensock.com/docs/Easing
                onComplete:() => {
                    disk.visible = true;
                    this._waitingLabel.visible = false;
                    this._jackpotRouletteLabelAnimation.stop();
                    this._jackpotRouletteLabelAnimation.visible = false;
    
                    resolve();
                }
            });
    
            this._rotationTween = new TimeLine();
            this._rotationTween.add(this.drivingTween);
            this._rotationTween.add(this.breakingTween);
            this._rotationTween.play();
        });
        
    }
    
    /**
     * @private
     * @description Shows sphere liquid animation
     * @param {Number} variant - variant to show
     * @returns {Promise} - promise to be resolved on animation stop
     * */
    showSphereFill (variant) {
        console.log('*** ROULETTE:showSphereFill');
        
        if (variant < 1 || variant > 4) {
            return Promise.reject(`parameter ${variant} out of bounds`);
        }
    
        if (this._rotationTween) {
            this._rotationTween.kill();
            this._rotationTween = null;
        }
        
        this._sndEnd.play();
        this._sndMusic.stop();
        // this._sndGold.play();
        
        this._waitingLabel.visible = false;
        
        return new Promise(resolve => {
            // let animation = null;
            //
            // switch (variant) {
            // case 4:
            //     animation = this._yellowSphere;
            //     break;
            // case 3:
            //     animation = this._greenSphere;
            //     break;
            // case 2:
            //     animation = this._blueSphere;
            //     break;
            // // case 1:
            // //     animation = this._violetSphere;
            // //     break;
            // }
            //
            // animation.visible = true;
            // animation.onComplete = () => {
            //     animation.visible = false;
                resolve();
            // };
            // animation.gotoAndPlay(0);
        });
    }
    
    /**
     * @private
     * @description Shows substrate blinking
     * @param {Number} variant - variant to show
     * @returns {Promise} - promise to be resolved on blinking stop
     * */
    showBlinkingSubstrate(variant) {
        console.log('*** ROULETTE:showBlinkingSubstrate');
        if (variant < 1 || variant > 4) {
            return Promise.reject(`parameter ${variant} out of bounds`);
        }
        

        let animation = null;
        let sound = null;
        let tintColor = null;
        let label = null;
        
        switch (variant) {
        case 4:
            animation = this._yellowSubstrate;
            sound = this._sndMegaJackpot;
            tintColor = this._megaJackpotTintColor;
            label = this._megaJackpotWinLabel;
            break;
        case 3:
            animation = this._greenSubstrate;
            sound = this._sndSuperJackpot;
            tintColor = this._superJackpotTintColor;
            label = this._superJackpotWinLabel;
            break;
        case 2:
            animation = this._blueSubstrate;
            sound = this._sndJackpot;
            tintColor = this._jackpotTintColor;
            label = this._jackpotWinLabel;
            break;
        // case 1:
        //     animation = this._violetSubstrate;
        //     sound = this._sndBonus;
        //     tintColor = this._bonusTintColor;
        //     label = this._bonusLabel;
        //     break;
        }
        
        sound.play();
        
        animation.visible = true;
        animation.alpha = 0;

        const onUpdate = tween => {
            const value = tween.target['value'];
    
            const alpha = (0.5 + 0.5 * Math.sin(value * Math.PI*12))*(0.999 - value) + value;
            animation.alpha = alpha;
    
            let red = (tintColor & 0xff0000) >> 16;
            red = red < Math.floor(alpha * 255) ? Math.floor(alpha * 255) : red;
            let green = (tintColor & 0x00ff00) >> 8;
            green = green < Math.floor(alpha * 255) ? Math.floor(alpha * 255) : green;
            let blue = (tintColor & 0x0000ff) >> 0;
            blue = blue < Math.floor(alpha * 255) ? Math.floor(alpha * 255) : blue;
    
            label.tint = (red << 16) | (green << 8) | blue;
        };

        return new Promise(resolve => {
            Tween.to({value: 0}, 3, {value:0.999, ease:Linear.easeNone, onUpdate:onUpdate, onUpdateParams:['{self}'], onComplete:resolve});
        });
    }
}



// WEBPACK FOOTER //
// ./src/library/roulette.es6